import { useNavigate } from "react-router-dom"

import Style from "./style"
import caution404 from "./asset/caution404.svg"
import DefaultButton from "shared/ui/DefaultButton"

const NotFound = () => {
    const navigate = useNavigate()

    return (
        <Style.WrapperDiv>
            <Style.CautionSvg src={caution404} />
            <Style.Title>죄송합니다.</Style.Title>
            <Style.ContentDiv>
                <p>해당 페이지를 찾을 수 없습니다.</p>
            </Style.ContentDiv>
            <Style.BtnDiv>
                <DefaultButton clickEvent={() => navigate("/")}>홈 으로 돌아가기</DefaultButton>
            </Style.BtnDiv>
        </Style.WrapperDiv>
    )
}

export default NotFound